import template from "lodash/template";

export default function fillHtml(item, type) {
    const templates = {
        material: template(`
        <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <div class="fl-card" itemtype="http://schema.org/Product" itemprop="itemListElement" itemscope="">
                <div class="fl-card-img">
                    <img src="<%= main_image %>">
                    <meta itemprop="image" content="<%= main_image %>">
                </div>
                <div class="fl-card-content">
                    <div class="fl-card-content-header" itemprop="name"><a href="<%= link %>" class="btn-link-gray large-text fw-bold mar-b-4" itemprop="url">
                        <%= name %>
                    </a></div>
                    <div class="fl-card-content-body">
                        <div class="price-block-mini mar-b-1" itemtype="http://schema.org/Offer" itemprop="offers" itemscope="">
                        <% if (Number(price[0]) !== 0) { %>
                            <span>от </span><span class="price-block__price"><%= price[0] %><sup>.<%= price[1] %></sup></span><span>
                            <% if (unit && unit.short ) { %>
                                руб./<%= unit.short %>
                            <% } else {%>
                                руб.
                            <% } %>
                            </span>
                        <% } else {%>
                            <span>цена </span><span class="price-block__price">по запросу<span>
                        <% } %>
                        <meta itemprop="price" content="<%= price.join('.') %>">
                        <meta itemprop="priceCurrency" content="RUB">
                        <link itemprop="availability" href="http://schema.org/InStock">
                        </div>
                        <div class="description-wrapper line-clamp-5 mar-b-4 small-text" itemprop="description">
                            <%= description %>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        `),

        fail: template(`
        <div class="infoblock-service-item">
            <div class="fl-card">
                <div class="fl-card-img">
                    <img src="<%= image %>" />
                </div>
                <div class="fl-card-content">
                    <% if (name) { %>
                        <p class="small-text fw-bold"><%= name %></p>
                    <% } %>
                    <div class="mar-t-1">
                        <span class="small-text">
                            <span class="fw-bold">Описание:</span>
                            <%= description %>
                        </span>
                    </div>
                    <div class="mar-t-1">
                        <span class="small-text">
                            <span class="fw-bold">Решение:</span>
                            <%= solution %>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        `),

        case: template(`
        <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <div class="fl-card">
            <div class="fl-card-img"><img src="<%= main_image %>"></div>
            <div class="fl-card-content">
                <div class="fl-card-content-header"><a href="<%= link %>" class="btn-link-gray large-text fw-bold mar-b-4">
                <%= title %>
                </a></div>
                <div class="fl-card-content-body">
                    <div class="pad-t-5">
                        <p class="small-text d-block mar-b-4">Дата сдачи: <b><%= end_date %></b></p>
                        <p class="small-text d-block mar-b-4">Площадь: <b><%= utils.numberWithSpaces(value) %>м2</b></p>
                        <p class="small-text d-block mar-b-4"><span>Тип решения: </span><a class="btn-link-gray fw-bold" href="<%= type.link %>"><%= type.title %></a></p>
                        <% if (solution) { %>
                            <p class="small-text d-block mar-b-4"><span>Решение: </span><a class="btn-link-gray fw-bold" href="<%= solution.link %>"><%= solution.title %></a></p>
                        <% } %>
                    </div>
                </div>
            </div>
            </div>
        </div>
        `),

        video: template(`
        <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <a data-fancybox="iframe" data-src="<%= link %>" class="infoblock-video">
                <div class="overlay">
                    <img src="/images/play.svg" class="icon" />
                    <span class="fw-bold large-text btn-link title"><%= title %></span>
                </div>
                <img src="<%= thumb %>" class="backdrop" />
            </a>
        </div>
        `),
    };

    if (type === "solution") {
        return templates.material({
            ...item,
            price: item.cache.full,
        });
    } else if (type === "service") {
        return templates.material({
            ...item,
            main_image: item.image,
            price: item.from_price,
        });
    }

    return templates[type](item);
}
